import React, { Component, useEffect, useState, Empty } from 'react';
import { Tooltip, Pagination, Select, Spin, Input } from 'antd';
import { getSwatches } from '../../apis/swatchApi';
import { fetchAllTasks, useFetchCompanyCode, useFetchTask } from '../../hooks/useTasks';
import { useQuery } from 'react-query';
import SpinLoader from '../../commonComponents/SpinLoader';
import useLogout from '../../hooks/useLogout';
import { EditOutlined } from '@ant-design/icons';
import DynamicModal from '../../commonComponents/DynamicModal/DynamicModal';
import EditSwatch from './EditSwatchModal';

export default function SwatchListing({ company = '641c3fdeb349b0994e69aacf' }) {
    // const [swatches, setSwatches] = useState([]);
    const { logout } = useLogout();
    const [companyCodeText, setCompanyCodeText] = useState('');
    const [pageNumber, setPageNumber] = useState(1);
    const [pageSize, setPageSize] = useState(100);
    const [swatchName, setSwatchName] = useState('');
    const [selectedSwatch, setSelectedSwatch] = useState(null);
    const [showEditModal, setShowEditModal] = useState(false);

    const FetchCompanyCodeError = err => {
        if (err.response.status === 401) logout();
    };
    const { data: companyCodeList } = useFetchCompanyCode(FetchCompanyCodeError);
    const [totalPage, setTotalPage] = useState(0);
    const oncompanyCodeChange = value => {
        setCompanyCodeText(value);
        dropdownFilter();
    };
    const dropdownFilter = () => {
        setPageNumber(1);
    };
    const fetchNextData = pageNum => {
        let pageNo = pageNum++;
        setPageNumber(pageNo);
    };

    const {
        data: swatchData,
        isLoading,
        isError,
        refetch: refetchSwatches,
    } = useQuery(['swatches', companyCodeText, pageNumber, pageSize, swatchName], getSwatches, {
        refetchOnWindowFocus: false,
        onSuccess: data => {
            setTotalPage(data.totalCount);
        },
    });
    const spinIcon = (
        <div className="spin-center">
            <Spin className="spin_loader" size="large" />{' '}
        </div>
    );
    const handleSearch = e => {
        setSwatchName(e.target.value);
        setPageNumber(1);
    };
    const handleEditing = swatch => {
        console.log('swatch ===>>>', swatch.labelName);
        setSelectedSwatch(swatch);
        setShowEditModal(true);
    };
    const onUpdateSwatchSuccess = () => {
        setShowEditModal(false);
        refetchSwatches();
    };
    return (
        <>
            {showEditModal && (
                <DynamicModal
                    open={showEditModal}
                    width={800}
                    closable={true}
                    close={() => setShowEditModal(false)}
                    component={
                        <EditSwatch
                            selectedSwatch={selectedSwatch}
                            refetchSwatches={() => refetchSwatches()}
                            closeEditModal={() => setShowEditModal(false)}
                            onUpdateSwatchSuccess={onUpdateSwatchSuccess}
                        />
                    }
                />
            )}
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    height: '30px',
                    alignItems: 'center',
                }}
            >
                <div
                    style={{
                        width: '200px',
                        margin: '5px',
                    }}
                >
                    <Input value={swatchName} size="small" placeholder="Search by name" name="search" onChange={handleSearch} />
                </div>
                <p>Select Client to Filter</p>
                <Select
                    placeholder="Select company code"
                    onChange={text => oncompanyCodeChange(text)}
                    className="filter_dropdown"
                    value={companyCodeText}
                >
                    <Select.Option key="none" value={''} size="small">
                        All
                    </Select.Option>
                    {companyCodeList?.map(el => {
                        return (
                            <Select.Option key={el.id} value={el}>
                                {el}
                            </Select.Option>
                        );
                    })}
                </Select>
            </div>
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    flexWrap: 'wrap',
                    alignItems: 'flex-start',
                    justifyContent: 'flex-start',
                    backgroundColor: '#E7E6E9',
                    height: 'calc(100% - 60px)',
                    overflow: 'auto',
                }}
            >
                <>
                    {!isLoading ? (
                        swatchData?.totalCount > 0 ? (
                            swatchData?.data?.map(swatch => {
                                return (
                                    <div
                                        key={swatch._id}
                                        style={{
                                            position: 'relative',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            // padding: "10px",
                                            backgroundColor: 'white',
                                            margin: '10px',
                                            padding: '10px',
                                            borderRadius: '5px',
                                            // width: "200px",
                                            // height: "300px",
                                        }}
                                    >
                                        <Tooltip title="Edit">
                                            <div
                                                style={{
                                                    position: 'absolute',
                                                    left: 0,
                                                    top: 0,
                                                    backgroundColor: 'rgba(185, 169, 169, 0.2392156863)',
                                                    margin: 5,
                                                    padding: 3,
                                                    color: '#575454',
                                                    borderRadius: 3,
                                                    cursor: 'pointer',
                                                }}
                                            >
                                                <EditOutlined onClick={() => handleEditing(swatch)} />
                                            </div>
                                        </Tooltip>
                                        <img
                                            src={swatch.image.thumbPath?.url}
                                            style={{
                                                width: '100px',
                                                height: '120px',
                                                borderRadius: '5px 5px 0 0',
                                                objectFit: 'contain',
                                            }}
                                            alt="swatch_img"
                                        />
                                        <Tooltip title={swatch.name}>
                                            <p
                                                style={{
                                                    textAlign: 'center',
                                                    width: '100px',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    whiteSpace: 'nowrap',
                                                    // fontSize:'12px'
                                                }}
                                            >
                                                Color
                                                <br />
                                                {swatch.name}
                                            </p>
                                        </Tooltip>
                                    </div>
                                );
                            })
                        ) : (
                            <p>No Data Found!</p>
                            // <Empty
                            //     description="No data available"
                            //     image={Empty.PRESENTED_IMAGE_SIMPLE}
                            //     imageStyle={{ marginTop: "200px" }}
                            // />
                        )
                    ) : (
                        <div className="spin-center">
                            <SpinLoader />
                        </div>
                    )}
                </>
            </div>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    height: '30px',
                }}
            >
                <Pagination
                    current={pageNumber}
                    pageSize={pageSize}
                    total={totalPage}
                    onChange={page => fetchNextData(page)}
                    defaultPageSize={pageSize}
                    showSizeChanger
                    disabled={isLoading}
                    pageSizeOptions={['50', '100']}
                    onShowSizeChange={(current, size) => {
                        setPageNumber(1);
                        setPageSize(size);
                    }}
                />
            </div>
        </>
    );
}
